import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
/* eslint-disable */
import "regenerator-runtime/runtime";
import { appReducer } from "./reducers";
import rootSaga from "./sagas";

const sagaMiddleware = createSagaMiddleware();

// Redux DevTools Extension support (compatible with Redux v5)
const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

export const store = createStore(
  appReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(rootSaga);
